import script from "./songlist.vue?vue&type=script&setup=true&lang=js"
export * from "./songlist.vue?vue&type=script&setup=true&lang=js"

import "./songlist.vue?vue&type=style&index=0&id=3b997f98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b997f98"]])

export default __exports__